import React, { useEffect, useState } from "react";
import {
  FaPlus,
  FaTrash,
  FaEdit,
  FaInfoCircle,
  FaStar,
  FaUser,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa"; 
import api from "../../services/axiosInstance"
import { useAuth } from "../../context/AuthContext";
import CourseCard from "./CourseCard"; 
import CourseDetailsCard from "./CourseDetailsCard";
import * as FaIcons from "react-icons/fa";

const ProfessorCourses = () => {
  const [iconImage, setIconImage] = useState(null);
  const { user } = useAuth();
  const profId = user?.id;
const [iconSearch, setIconSearch] = useState("");
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    price: "",
    duree: "",
    niveau: "",
    certificat: "",
    prerequis: "",
    learn: "",
    programme: [],
    category: "" ,
    icon: ""
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [coursesPerPage] = useState(6); // 6 courses per page for better grid layout
  const renderIcon = (iconName, className = "text-2xl") => {
  if (!iconName) return null;
  const IconComponent = FaIcons[iconName];
  if (!IconComponent) return null;
  return <IconComponent className={className} />;
};

  const filteredIcons = Object.keys(FaIcons)
  .filter((iconName) =>
    iconName.toLowerCase().includes(iconSearch.toLowerCase())
  )
  .slice(0, 200); // limit for performance

  // Fetch professor's courses
  const fetchCourses = async () => {
  try {
    setLoading(true);

    const res = await api.get(`/courses/prof/${profId}`);
    setCourses(res.data);
    setCurrentPage(1); // Reset to first page when courses change

  } catch (err) {
    console.error("Error fetching courses:", err.response?.data || err.message);
    alert(err.response?.data?.message || "Erreur lors du chargement des cours");
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    if (profId) fetchCourses();
  }, [profId]);

  // Pagination logic
  const indexOfLastCourse = currentPage * coursesPerPage;
  const indexOfFirstCourse = indexOfLastCourse - coursesPerPage;
  const currentCourses = courses.slice(indexOfFirstCourse, indexOfLastCourse);
  const totalPages = Math.ceil(courses.length / coursesPerPage);

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const goToPage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Open Add Modal
  const openAddModal = () => {
  setSelectedCourse(null);
  setFormData({
    name: "",
    description: "",
    price: "",
    duree: "",
    niveau: "",
    certificat: "",
    prerequis: "",
    learn: "",
    programme: [],
    category: "",
    icon: "FaBook" // default icon
  });
  setIsModalOpen(true);
};


  // Open Edit Modal
  const openEditModal = (course) => {
    // Ensure programme is always an array
    const courseData = {
      ...course,
      programme: Array.isArray(course.programme) ? course.programme : [],
      category: course.category || "",
      icon: course.icon || ""
    };
    setFormData(courseData);
    setSelectedCourse(course);
    setIsModalOpen(true);
  };

  // Create or Update Course
 const handleSave = async () => {
  try {
    
  const fd = new FormData();

  Object.entries(formData).forEach(([key, value]) => {
    if (key !== "programme") fd.append(key, value);
  });

  fd.append("programme", JSON.stringify(formData.programme));

  if (iconImage) {
    fd.append("iconImage", iconImage);
  }

  if (selectedCourse) {
    await api.put(`/courses/${selectedCourse.id}`, fd);
  } else {
    await api.post(`/courses/create/${profId}`, fd);
  }

   alert(selectedCourse ? "Cours mis à jour !" : "Cours ajouté !");
    setIsModalOpen(false);
    fetchCourses();

  } catch (err) {
    console.error("Erreur lors de l'enregistrement :", err.response?.data || err.message);
    alert(err.response?.data?.message || "Erreur lors de l'enregistrement");
  }
};


  // Delete Course
  const handleDelete = async (id) => {
    if (!window.confirm("Supprimer ce cours ?")) return;
    try {
      const res = await api.delete(`/courses/${id}`);
    
        alert("Cours supprimé !");
        fetchCourses();
      
    } catch (err) {
      console.error("Delete error:", err);
    }
  };

  // Utility functions for CourseDetailsCard
  const getCourseBenefits = (courseId) => {
    const course = courses.find(c => c.id === courseId);
    return course?.learn ? [course.learn] : ["Compétences pratiques avancées"];
  };

  const getCoursePrerequisites = (courseId) => {
    const course = courses.find(c => c.id === courseId);
    return course?.prerequis ? [course.prerequis] : ["Aucun prérequis nécessaire"];
  };

  const getInstructorInfo = (courseId) => {
  const course = courses.find(c => c.id === courseId);
  if (!course) return {};
  return {
    name: course.instructor_name || "Non spécifiée",
    email: course.instructor_email || "Email non disponible",
    phone: course.instructor_phone || "Non spécifié",
    wilaya: course.instructor_wilaya || "Non spécifiée",
    bio: course.instructor_bio || "Non spécifiée",
    achievements: course.instructor_achievements
      ? Array.isArray(course.instructor_achievements)
        ? course.instructor_achievements
        : [course.instructor_achievements]
      : ["Non spécifiée"],
  };
};
 
  const registerCourse = (courseId, courseName) => {
  const phoneNumber = "213549075577";
  const message = `Bonjour ! Je suis intéressé(e) par la formation "${courseName}". Pouvez-vous me donner plus d'informations ?`;
  
  const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
  window.open(whatsappURL, "_blank");
};

  // Generate page numbers for pagination
  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = 5;
    
    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      const startPage = Math.max(1, currentPage - 2);
      const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
      
      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
      }
    }
    
    return pageNumbers;
  };

  if (loading)
    return <p className="text-center text-gray-600 mt-10">Chargement...</p>;

  return (
    <div className="p-8 bg-gray-50 min-h-screen mt-12">
      <div className="flex justify-between items-center mb-10">
        <h2 className="text-3xl font-bold text-gray-800 flex items-center gap-3">
          <FaStar className="text-yellow-500" /> Mes Cours
        </h2>
        <button
          onClick={openAddModal}
          className="bg-emerald-600 text-white px-5 py-2 rounded-lg hover:bg-emerald-700 transition flex items-center gap-2"
        >
          <FaPlus /> Ajouter un cours
        </button> 
      </div>

      {/* Courses count and pagination info */}
      <div className="flex justify-between items-center mb-6">
        <p className="text-gray-600">
          {courses.length} cours au total
        </p>
        {courses.length > coursesPerPage && (
          <p className="text-gray-600">
            Page {currentPage} sur {totalPages}
          </p>
        )}
      </div>

      {/* Courses grid */}
      {courses.length <= 0 ? (
        <p className="text-center text-gray-500">Aucun cours trouvé.</p>
      ) : (
        <>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {currentCourses.map((course) => (
              <CourseCard
                key={course.id}
                course={course}
                onView={() => setSelectedCourse(course)}
                onEdit={() => openEditModal(course)}
                onDelete={() => handleDelete(course.id)}
                isProfessorView={true}
              />
            ))}
          </div>

          {/* Pagination Controls */}
          {courses.length > coursesPerPage && (
            <div className="flex justify-center items-center mt-12 space-x-2">
              {/* Previous Button */}
              <button
                onClick={prevPage}
                disabled={currentPage === 1}
                className={`flex items-center justify-center w-10 h-10 rounded-lg transition-all duration-300 ${
                  currentPage === 1
                    ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                    : "bg-blue-600 text-white hover:bg-blue-700 shadow-lg hover:shadow-xl"
                }`}
              >
                <FaChevronLeft className="text-sm" />
              </button>

              {/* Page Numbers */}
              <div className="flex items-center space-x-1">
                {getPageNumbers().map((pageNumber) => (
                  <button
                    key={pageNumber}
                    onClick={() => goToPage(pageNumber)}
                    className={`w-10 h-10 rounded-lg transition-all duration-300 font-medium ${
                      currentPage === pageNumber
                        ? "bg-blue-600 text-white shadow-lg"
                        : "bg-white text-gray-700 hover:bg-gray-100 border border-gray-300"
                    }`}
                  >
                    {pageNumber}
                  </button>
                ))}
              </div>

              {/* Next Button */}
              <button
                onClick={nextPage}
                disabled={currentPage === totalPages}
                className={`flex items-center justify-center w-10 h-10 rounded-lg transition-all duration-300 ${
                  currentPage === totalPages
                    ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                    : "bg-blue-600 text-white hover:bg-blue-700 shadow-lg hover:shadow-xl"
                }`}
              >
                <FaChevronRight className="text-sm" />
              </button>
            </div>
          )}
        </>
      )}

      {/* Course Details Modal */}
      {selectedCourse && !isModalOpen && (
  <div
    className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
    onClick={() => setSelectedCourse(null)} // 👈 close on outside click
  >
    <div
      className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
      onClick={(e) => e.stopPropagation()} // 👈 prevent close when clicking card
    >
      <CourseDetailsCard
        course={selectedCourse}
        onClose={() => setSelectedCourse(null)}
        getCourseBenefits={getCourseBenefits}
        getCoursePrerequisites={getCoursePrerequisites}
        getInstructorInfo={getInstructorInfo}
        registerCourse={registerCourse}
        backToCourses={() => setSelectedCourse(null)}
        closeModal={() => setSelectedCourse(null)}
      />
    </div>
  </div>
)}

 
      {/* Add/Edit Course Modal */}
      {isModalOpen && (
        <div
    className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
    onClick={() => setIsModalOpen(false)} // 👈 close outside
  >
    <div
      className="bg-white p-8 rounded-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto"
      onClick={(e) => e.stopPropagation()} // 👈 keep modal open
    >    <h3 className="text-2xl font-bold mb-6">
              {selectedCourse ? "Modifier le cours" : "Ajouter un nouveau cours"}
            </h3>

            <div className="grid gap-4">
              {/* Basic course info */}
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Nom du cours *"
                className="border p-3 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                required
              />
              <textarea
                name="description"
                value={formData.description}
                onChange={handleChange}
                placeholder="Description *"
                rows="3"
                className="border p-3 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                required
              />
              <div>
  <label className="font-semibold mb-2 block">Icône du cours</label>
<div className="mt-4">
  <label className="font-semibold block mb-2">
    image pour l'icône du formation :
  </label> 

  <input
    type="file"
    accept="image/png,image/jpeg,image/svg+xml"
    onChange={(e) => {
      setIconImage(e.target.files[0]);
      setFormData((prev) => ({ ...prev, icon: "" }));
    }}
  />

  {iconImage && (
    <p className="text-sm text-green-600 mt-1">
      Image sélectionnée : {iconImage.name}
    </p>
  )}
</div>

  {/* Search input */}
  {/* <input
    type="text"
    value={iconSearch}
    onChange={(e) => setIconSearch(e.target.value)}
    placeholder="Rechercher une icône (ex: star, user, book...)"
    className="border p-3 rounded-lg w-full mb-3 focus:ring-2 focus:ring-blue-500"
  /> */}

  {/* Selected Icon Preview */}
  {/* {!iconImage && (
  <div className="flex items-center gap-2 mb-3">
    {renderIcon(formData.icon, "text-2xl")}
    <span>{formData.icon}</span>
  </div>
)} */}


  {/* Icons grid */}
  {/* <div className="grid grid-cols-8 gap-3 max-h-64 overflow-y-auto p-2 border rounded-lg">
    {filteredIcons.map((iconName) => {
  const IconComponent = FaIcons[iconName];
  if (!IconComponent) return null;

  return (
    <div
      key={iconName}
      onClick={() => {
        setIconImage(null);
        setFormData((prev) => ({ ...prev, icon: iconName }));
      }}
      className={`p-2 rounded-lg cursor-pointer border flex items-center justify-center transition ${
        formData.icon === iconName
          ? "bg-blue-600 text-white"
          : "hover:bg-gray-100"
      }`}
    >
      <IconComponent className="text-xl" />
    </div>
  );
})}

  </div> */}
</div>

              <div className="grid grid-cols-2 gap-4">
                <input
                  type="number"
                  name="price"
                  value={formData.price}
                  onChange={handleChange}
                  placeholder="Prix *"
                  className="border p-3 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  required
                />
                <input
                  type="text"
                  name="duree"
                  value={formData.duree}
                  onChange={handleChange}
                  placeholder="Durée (ex: 3 semaines)"
                  className="border p-3 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <input
                  type="text"
                  name="niveau"
                  value={formData.niveau}
                  onChange={handleChange}
                  placeholder="Niveau (débutant, avancé...)"
                  className="border p-3 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                {/* Category field */}
<select
  name="category"
  value={formData.category}
  onChange={handleChange}
  className="border p-3 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
  required
>
  <option value="">-- Choisir une catégorie --</option>
  <option value="Architecture">Architecture</option>
  <option value="Rendering">Rendering</option>
  <option value="Design">Design</option>
  <option value="Académique">Académique</option>
</select>

                <input
                  type="text"
                  name="certificat"
                  value={formData.certificat}
                  onChange={handleChange}
                  placeholder="Type de certificat"
                  className="border p-3 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />

              </div>

              <textarea
                name="prerequis"
                value={formData.prerequis}
                onChange={handleChange}
                placeholder="Prérequis"
                rows="2"
                className="border p-3 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />

              <textarea
                name="learn"
                value={formData.learn}
                onChange={handleChange}
                placeholder="Ce que les étudiants apprendront"
                rows="3"
                className="border p-3 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />

              {/* Programme Section */}
              <div className="mt-4">
                <h4 className="font-semibold text-lg mb-3">Chapitres du programme</h4>

                {(formData.programme || []).map((ch, index) => (
                  <div key={index} className="border p-4 rounded-lg mb-3 bg-gray-50">
                    <input
                      type="text"
                      placeholder="Nom du chapitre"
                      value={ch.chapter || ""}
                      onChange={(e) => {
                        const newProg = [...(formData.programme || [])];
                        newProg[index] = { ...newProg[index], chapter: e.target.value };
                        setFormData((prev) => ({ ...prev, programme: newProg }));
                      }}
                      className="border p-2 rounded w-full mb-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                    <textarea
                      placeholder="Description du chapitre"
                      value={ch.description || ""}
                      onChange={(e) => {
                        const newProg = [...(formData.programme || [])];
                        newProg[index] = { ...newProg[index], description: e.target.value };
                        setFormData((prev) => ({ ...prev, programme: newProg }));
                      }}
                      className="border p-2 rounded w-full focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      rows="2"
                    />
                    <button
                      onClick={() => {
                        const newProg = (formData.programme || []).filter(
                          (_, i) => i !== index
                        );
                        setFormData((prev) => ({ ...prev, programme: newProg }));
                      }}
                      className="text-red-500 text-sm mt-2 hover:text-red-700"
                    >
                      Supprimer ce chapitre
                    </button>
                  </div>
                ))}

                <button
                  onClick={() =>
                    setFormData((prev) => ({
                      ...prev,
                      programme: [
                        ...(prev.programme || []),
                        { chapter: "", description: "" },
                      ],
                    }))
                  }
                  className="mt-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition flex items-center gap-2"
                >
                  <FaPlus /> Ajouter un chapitre
                </button>
              </div>
            </div>

            {/* Action buttons */}
            <div className="flex justify-end gap-3 mt-6">
              <button
                onClick={() => setIsModalOpen(false)}
                className="px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-100 transition"
              >
                Annuler
              </button>
              <button
                onClick={handleSave}
                className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
              >
                {selectedCourse ? "Modifier" : "Créer"} le cours
              </button>
            </div>
          </div>
        </div>
      )} 
    </div>
  );
};

export default ProfessorCourses;